import type { EntryPointRouteParams } from '@jira/platform__entry-points-plugin-types/src/types.tsx';
import { JSResourceForUserVisible } from '@atlassian/react-async';
import parameters from '@atlassian/jira-relay/src/__generated__/src_jiraBusinessOverviewCalendarQuery$parameters';
import { createEntryPoint } from '@atlassian/react-entrypoint';

export const overviewCalendarEntrypoint = createEntryPoint({
	root: JSResourceForUserVisible(
		() => import(/* webpackChunkName: "async-business-overview-calendar-entrypoint" */ './src'),
	),
	getPreloadProps: ({ tenantContext: { cloudId } }: EntryPointRouteParams) => {
		return {
			queries: {
				overviewCalendarQuery: {
					options: {
						fetchPolicy: 'store-and-network' as const,
					},
					parameters,
					variables: {
						cloudId,
					},
				},
			},
		};
	},
});
